import { Injectable } from '@angular/core';

import { DataService } from '../data.service';
import { SimpleRepository } from './_simple.repository';
import { Gal } from 'src/app/model/orm/gal.model';
import { IGetallDTO } from 'src/app/model/dto/getall.dto';

@Injectable()
export class GalsRepository extends SimpleRepository<Gal> {
    constructor(protected dataService: DataService) {
        super();
        this.sortBy = "name";
    }
    
    public load(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (new Date().getTime() - this.loadedAt < this.ttl) {
                resolve();
            } else {                
                const dto: IGetallDTO = {sortBy: this.sortBy, sortDir: this.sortDir};
                this.dataService.galsAll(dto).subscribe(res => {                         
                    if (res.statusCode === 200) {
                        this.build(res.data);
                        this.loadedAt = new Date().getTime();
                        resolve();
                    } else {                        
                        reject(res.statusCode+": "+res.error);
                    }
                }, err => {
                    reject(err.message);
                });
            }            
        });
    }    

    public build(gals: Array<Gal> = []): void {
        this.xl = gals.length ? gals.map(d => new Gal().build(d)) : [];
    }
}
